import React, {useEffect, useState} from 'react';
import FleetStatusSummary from './fleetStatusSummary/fleetStatusSummary';
import FleetByStatus from './fleetByStatus/fleetByStatus';
import Issues from './issues/issues';
import PrintDataButton from './report/report';
import './dashboard.scss';
// import {GetCellValue} from './gspreadApi';


export default function Dashboard({depot, allItems, allIssues}) {
  const [filterItems, setFilterItems] = useState(null);
  const [filterIssues, setFilterIssues] = useState(null);



    useEffect(() =>{

      async function filterData() {
        if (allItems&&depot!=='All') {
          const filteredItems = await allItems.filter(obj => (obj.group_name || '').includes(depot));
          const vehiclesArray = await filteredItems.map(obj => obj.name);
          setFilterItems(filteredItems);
          setFilterIssues(allIssues ? allIssues.filter(obj => vehiclesArray.includes(obj.asset.name)) : null);
        }
        else if (allItems&&depot==='All') {
          setFilterItems(allItems);
          setFilterIssues(allIssues);
        }
      }
      filterData();
      
    }, [depot, allIssues, allItems])


  if (!filterItems) {
    return <div className='loader-box'>
    <div className='loader'></div>
    </div>
  }
  else {
    return <div className='dashboard-grid'>
        <FleetStatusSummary items={filterItems} action={filterIssues ? <PrintDataButton items={filterItems} depot={depot} issues={filterIssues} /> : null} />
        <FleetByStatus items={filterItems} depot={depot} statusNames={['Out of Service']} title='OOS' issues={filterIssues} />
        <FleetByStatus items={filterItems} depot={depot} statusNames={['At Vendor']} title='At Vendor' />
        <FleetByStatus items={filterItems} depot={depot} statusNames={['For Vendor - Out of Service', 'For Vendor']} title='For Vendor' />
        <Issues issues={filterIssues} depot={depot} vehicles={filterItems} type='Accident'/> 
        <Issues issues={filterIssues} depot={depot} vehicles={filterItems} type='Breakdown'/>
      </div>

  }
  
}
 
















// These functions where created to extract data from worksheeets, howveer it was not possible because gspread api requeires a service account or a publicly accesible worksheet when using javascript/ front end app

// function loadDriveApi() {
//   return new Promise((resolve) => {
//     gapi.load('client', () => {
//       gapi.client.init({
//         apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
//         discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
//       }).then(() => {
//         resolve(gapi.client.drive);
//       });
//     });
//   });
// }
// function loadSheetsApi() {
//   return new Promise((resolve) => {
//     gapi.load('client', () => {
//       gapi.client.init({
//         apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
//         discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
//       }).then(() => {
//         resolve(gapi.client.sheets);
//       });
//     });
//   });
// }

// async function GetCellValue(driveId, spreadsheetTitle, worksheetName, cellValue) {
//   let cell;

//   const driveApi = await loadDriveApi(); // Replace with your own code to load the Drive API.
//   const sheetsApi = await loadSheetsApi(); // Replace with your own code to load the Sheets API.

//   // Get the spreadsheet ID from the title and the Drive ID.
//   const spreadsheetQuery = `name='${spreadsheetTitle}' and mimeType='application/vnd.google-apps.spreadsheet' and trashed = false`;
//   const response = await driveApi.files.list({
//     q: `${spreadsheetQuery} and parents='${driveId}'`,
//     fields: 'nextPageToken, files(id)',
//   });
//   const [spreadsheet] = response.result.files;

//   // Get the worksheet ID from the worksheet name and the spreadsheet ID.
//   const sheetsResponse = await sheetsApi.spreadsheets.get({
//     spreadsheetId: spreadsheet.id,
//     includeGridData: false,
//   });
//   const worksheets = sheetsResponse.result.sheets;
//   const worksheet = worksheets.find((sheet) => sheet.properties.title === worksheetName);
//   const worksheetId = worksheet.properties.sheetId;

//   // Get the cell value from the worksheet ID and the cell value.
//   const range = `${worksheetName}!${cellValue}`;
//   const valueResponse = await sheetsApi.spreadsheets.values.get({
//     spreadsheetId: spreadsheet.id,
//     range,
//   });
//   const [row] = valueResponse.result.values;
//   cell = row[0];

// return cell;
// }


//   function getRas() {
//     const today = new Date();
//     const dayOfWeek = today.getDay();
//     const daysSinceMonday = (dayOfWeek + 6) % 7; // 0 = Monday, 1 = Tuesday, etc.
//     const latestMonday = new Date(today.getTime() - daysSinceMonday * 24 * 60 * 60 * 1000);
  
//     // Format the date as "RAS YYY-MM-DD"
//     const year = latestMonday.getFullYear();
//     const month = String(latestMonday.getMonth() + 1).padStart(2, '0');
//     const day = String(latestMonday.getDate()).padStart(2, '0');
//     const dateStr = `RAS ${year}-${month}-${day}`;
  
//     return dayOfWeek === 1 ? `RAS ${today.toISOString().substring(0, 10)}` : dateStr;
//   }